import { useModalStore } from '@/entities/Modal';
import { ResponseError } from '@/shared/api/types';
import { useMutation } from '@tanstack/react-query';
import { useAuth, useUserStore } from '@/entities/User';
import { useGlobalStore } from '@/entities/GlobalStore';
import { updateGoal } from '../api/updateGoal';
import { SelectedGoalParams } from '../ui/GoalModal';

export const useUpdateGoal = () => {
    const {
        user: { userId, goalRooms, goalMeters },
    } = useUserStore();
    const { setSelectedGoalParams } = useGlobalStore();
    const { setErrorModalProps, setIsGoalModalOpen, setIsGoalChosenModalOpen, setIsGoalUpdatedModalOpen } = useModalStore();
    const { mutate: authenticate } = useAuth();

    const hasGoal = Boolean(goalRooms && goalMeters);

    return useMutation({
        mutationFn: updateGoal,
        onSuccess: () => {
            setIsGoalModalOpen(false);
            setSelectedGoalParams({} as SelectedGoalParams);
            authenticate({ id: userId });

            const handlerToOpenModal = hasGoal ? setIsGoalUpdatedModalOpen : setIsGoalChosenModalOpen;

            handlerToOpenModal(true);
        },
        onError: (error: ResponseError) => {
            setIsGoalModalOpen(false);
            setSelectedGoalParams({} as SelectedGoalParams);
            const errorMessage = error.response.data.details[0] || 'Что-то пошло не так';

            setErrorModalProps({ isOpened: true, title: errorMessage });
        },
    });
};
